import React, { useState, useRef, useEffect, useMemo } from "react";
import SSPCommonModal from "../../CommonComponents/SSPCommonModal/SSPCommonModal";
import { PageBar, SSPCommonButton, } from "../../CommonComponents";
import Grid from "@mui/material/Grid";
import { Box, Card, CardContent, CardHeader, Divider, Link, Button, Tooltip, Typography, IconButton } from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import { post } from "../../services";
import Cookies from "js-cookie";
import Loader from "../../CommonComponents/Loader";
import axios from "axios";
import { styles, } from './Styles';
import styled from 'styled-components';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { Create, Download } from "@mui/icons-material";
import Select from "react-select";
import SearchIcon from '@mui/icons-material/Search';

const base = "https://";

const ApproveProvisions = ({ token }) => {
    const id = Cookies.get("ssp_id");
    const domain_id = Cookies.get("ssp_domain_id");
    const [selectedPendingPeriods, setSelectedPendingPeriods] = useState([]);
    const [selectedReviewedPeriods, setSelectedReviewedPeriods] = useState([]);
    const [provisionPeriodApiList, setProvisionPeriodApiList] = useState([]);

    const [status, setStatus] = useState('');
    const [businessUnit, setBusinesUnit] = useState([]);
    const [pendingBusinessUnit, setPendingBusinessUnit] = useState([]);

    const [businessUnitOptions, setbusinessUnitOptions] = useState([]);
    const [businessUnitApiList, setBusinessUnitApiList] = useState([]);
    const [approvalStatusApiList, setApprovalStatusApiList] = useState([]);

    const [loading, setLoading] = useState(false);
    const [modalOpener, setmodalOpener] = useState(false);
    const [message, setmessage] = useState("");
    const fileInputRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [row, setRows] = useState([]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    useEffect(() => {
        getDropdownData();
        rowFetch();
    }, []);

    const rowFetch = async () => {
        let response = await post(
            base + "ya8zbsuisd.execute-api.ap-south-1.amazonaws.com/prod/ssp_ht_prod",
            { "action": "provision/upload_details", "module_name": "approve_provisions" },
            true,
            false
        );
        if (response?.status === "success" || response?.body?.status === "success") {
            const rowsData = response?.body?.data?.map((row, index) => ({
                ...row,
                id: index + 1,
            }));
            setRows(rowsData);

        } else {
            setmessage("No Rows");
            setmodalOpener(true);
        }
    };

    const getDropdownData = async () => {
        setLoading(true);
        let payload = { "action": "provision/get_dropdown_list" }

        let response = await post(
            base + "ya8zbsuisd.execute-api.ap-south-1.amazonaws.com/prod/ssp_ht_prod",
            payload,
            true,
            false
        );

        if (response?.status === "success" || response?.body?.status === "success") {
            const data = response?.body?.data || {};
            setBusinessUnitApiList(data.business_unit || []);
            setApprovalStatusApiList(data.approval_status || []);
            // --- ADDED: Set Provision Periods from API ---
            setProvisionPeriodApiList(data.provision_period || []);
            setLoading(false);
        } else {
            setmessage(response?.message || response?.body?.message || "Failed to load dropdown data.");
            setmodalOpener(true);
            setLoading(false);
        }
    }

    const businessUnitSelectOptions = useMemo(() => {
        return businessUnitApiList?.map(unitName => ({
            label: unitName,
            value: unitName
        }));
    }, [businessUnitApiList]);

    const statusSelectOptions = useMemo(() => {
        return approvalStatusApiList?.map(statusName => ({
            label: statusName,
            value: statusName
        })) || [];
    }, [approvalStatusApiList]);

    // --- ADDED: Period Options ---
    const periodOptions = useMemo(() => {
        return provisionPeriodApiList?.map(p => ({
            label: p,
            value: p
        }));
    }, [provisionPeriodApiList]);

    const handleDownloadPendingApprovalFile = async () => {
        if (!selectedPendingPeriods || selectedPendingPeriods.length === 0) {
            setmessage("Please select at least one provision period.");
            setmodalOpener(true);
            return;
        }
        setLoading(true);

        let payload = {
            "action": "provision/provision_approval_pending",
            "provision_period": selectedPendingPeriods.map(p => p.value), // Send array
            "business_unit": pendingBusinessUnit.map(item => item.value),
        };

        let response = await post(
            base + "ya8zbsuisd.execute-api.ap-south-1.amazonaws.com/prod/ssp_ht_prod",
            payload,
            true,
            false
        );

        if (response?.status === "success" || response?.body?.status === "success") {
            window.open(response?.body?.data || response?.data);
            setLoading(false);
            setSelectedPendingPeriods([]);
            setPendingBusinessUnit([]);
        } else {
            setmessage(response?.message || response?.body?.message);
            setmodalOpener(true);
            setLoading(false);
        }

    }

    const handleDownloadFile = async () => {
        if (!selectedReviewedPeriods || selectedReviewedPeriods.length === 0) {
            setmessage("Please select at least one provision period.");
            setmodalOpener(true);
            return;
        }
        setLoading(true);

        let payload = {
            "action": "provision/previous_reviewed_provision",
            "provision_period": selectedReviewedPeriods.map(p => p.value), // Send array
            "business_unit": businessUnit.map(item => item.value),
            "status": status
        };

        let response = await post(
            base + "ya8zbsuisd.execute-api.ap-south-1.amazonaws.com/prod/ssp_ht_prod",
            payload,
            true,
            false
        );

        if (response?.status === "success" || response?.body?.status === "success") {
            window.open(response?.body?.data || response?.data);
            setLoading(false);
            setSelectedReviewedPeriods([]);
            setBusinesUnit([]);
            setStatus('');
        } else {
            setmessage(response?.message || response?.body?.message);
            setmodalOpener(true);
            setLoading(false);
        }
    }

    const downloadProcessLog = async (logId) => {
        setLoading(true)
        let response = await post(
            base + "ya8zbsuisd.execute-api.ap-south-1.amazonaws.com/prod/ssp_ht_prod",
            { "action": "provision/process_log", "module_name": "approve_provisions", "log_id": String(logId) },
            true, false
        );
        if (response?.status === "success" || response?.body?.status === "success") {
            setLoading(false)
            window.open(response?.body?.data || response?.data);
        } else {
            setLoading(false)
            setmessage(response?.body?.message || response?.message);
            setmodalOpener(true);
        }
    }

    const handleUpload = async () => {
        if (selectedFile) {
            if (selectedFile instanceof File) {
                const fileExtension = selectedFile.name.split('.').pop().toLowerCase();
                if (fileExtension !== "xlsx") {
                    setmessage("Only .xlsx files are allowed.");
                    setmodalOpener(true);
                    return;
                }
            }
            setLoading(true)
            let filenameWithTimestamp;
            if (selectedFile instanceof File) {
                const timestamp = new Date().toISOString().replace(/[-:.]/g, "").slice(0, 15);
                filenameWithTimestamp = `${selectedFile?.name.split(".").slice(0, -1).join(".")}_${timestamp}.${selectedFile?.name?.split(".")?.pop()}`;
            } else {
                filenameWithTimestamp = selectedFile;
            }
            let presignedUrlResponse = await post(
                base + "ya8zbsuisd.execute-api.ap-south-1.amazonaws.com/prod/ssp_ht_prod",
                { "action": "provision/gen_pre_url", "type": "approve", "filename": filenameWithTimestamp?.replace(/[()]/g, "") },
                true, false
            );
            if (presignedUrlResponse?.status === 'error' || presignedUrlResponse?.body?.status === 'error') {
                setmessage(presignedUrlResponse?.data?.message);
                setmodalOpener(true);
                return
            }
            const presignedUrl = presignedUrlResponse.body.data;
            if (!presignedUrl) return;

            if (selectedFile instanceof File) {
                const fileUploaded = await uploadFileWithPresignedUrl(selectedFile, presignedUrl);
                if (fileUploaded) {
                    let response = await post(
                        base + "ya8zbsuisd.execute-api.ap-south-1.amazonaws.com/prod/ssp_ht_prod",
                        { "action": "provision/approve_provisions", "filename": presignedUrl.fields.key },
                        true, false
                    );
                    if (response?.status === "success" || response?.body?.status === "success") {
                        setLoading(false)
                        setmessage(response?.message || response?.body?.message || "File Uploaded");
                        setmodalOpener(true);
                        if (fileInputRef.current) fileInputRef.current.value = "";
                        setSelectedFile(null);
                        setTimeout(() => window.location.reload(), 2000);
                    } else {
                        setLoading(false)
                        setmessage(response?.message || response?.body?.message || "Upload Failed");
                        setmodalOpener(true);
                        if (fileInputRef.current) fileInputRef.current.value = "";
                        setSelectedFile(null);
                    }
                }
            }
        } else {
            setLoading(false)
            setmessage("Please select file to upload");
            setmodalOpener(true);
        }
    }

    const uploadFileWithPresignedUrl = async (filetoUpload, generatedUrl) => {
        try {
            const fileUploadData = new FormData();
            Object.keys(generatedUrl.fields).forEach((key) => {
                fileUploadData.append(key, generatedUrl.fields[key]);
            });
            fileUploadData.append("file", filetoUpload);
            const response = await axios.post(generatedUrl.url, fileUploadData);
            return response.status >= 200 && response.status < 300;
        } catch (error) {
            console.error("Error during file upload:", error);
            throw error;
        }
    };

    const ReasonCell = ({ value }) => (
        <Tooltip title={<span style={{ fontSize: "16px" }}>{value}</span>}>
            <div style={{ whiteSpace: "none", textAlign: "start", maxWidth: "100%" }}>{value}</div>
        </Tooltip>
    );

    const columns = [
        {
            field: 'sr_no', headerName: 'Sr no', headerAlign: 'center',
            align: 'center', width: isMobile ? 150 : 90, headerAlign: 'center',
            align: 'center', renderCell: (params) => <div>{params.id}</div>
        },
        {
            field: 'log_id', headerName: 'Log id', headerAlign: 'center',
            align: 'center', width: isMobile ? 150 : 130, renderCell: (params) => <div>{params.value}</div>
        },
        {
            field: "file_name", headerName: " File Name", width: 220, headerAlign: 'center',
            align: 'center', renderCell: (params) => <ReasonCell value={params.value || "--"} />
        },
        {
            field: 'created_at', headerName: 'Date', headerAlign: 'center',
            align: 'center', width: isMobile ? 180 : 160, renderCell: (params) => <div style={{ textAlign: 'center' }}>{params.value || "--"}</div>
        },
        {
            field: 'status', headerName: 'Status', headerAlign: 'center',
            align: 'center', width: 150, renderCell: (params) => <div style={{ textAlign: 'center', color: params.value === 'Success' ? 'green' : 'red' }}>{params.value}</div>
        },
        {
            field: 'affected_count', headerName: 'No of records processed', headerAlign: 'center',
            align: 'center', width: isMobile ? 180 : 200, renderCell: (params) => <div style={{ textAlign: 'center' }}>{params?.value || '0'}</div>
        },
        {
            field: "current_status", headerName: "Progress", headerAlign: 'center',
            align: 'center', width: isMobile ? 170 : 200,
            renderCell: (params) => (
                <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" width="100%" height="100%">
                    <Typography style={{ fontSize: "0.9rem", color: params.value.includes('Partial') ? 'red' : 'green' }}>
                        {params.value}
                    </Typography>
                </Box>
            ),
        },
        {
            field: "process_log", headerName: "Process Log", headerAlign: 'center',
            align: 'center', width: 155,
            renderCell: (params) => (
                <IconButton onClick={() => downloadProcessLog(params.row.log_id)}>
                    <Download color="primary" />
                </IconButton>
            ),
        },
    ];

    const selectStyles = {
        container: (base) => ({
            ...base,
            width: '100%',
            zIndex: 99
        }),
        control: (base) => ({
            ...base,
            // paddingLeft: "30px", // Removed extra padding
            minHeight: "40px",
            height: "auto",
            borderColor: "black",
            backgroundColor: "white",
        }),
        valueContainer: (base) => ({
            ...base,
            paddingLeft: "8px",
            display: "flex",
            flexWrap: "wrap",
        }),
        multiValue: (base) => ({
            ...base,
            maxWidth: "100%",
        }),
        menu: (base) => ({ ...base, zIndex: 9999 }),
    };

    return (
        <Box>
            <Loader loading={loading} />
            <PageBar text="Fusion : Approve Provisions" />
            <Card sx={styles.assetmasterCard} >

                {/* --- Step 1: Pending Approval --- */}
                <CardHeader
                    p={2} sx={{ ...styles.cardHeader, marginTop: 1 }}
                    title={"Step 1: Download provisions pending approval"}
                    titleTypographyProps={{ sx: { fontSize: "16px", fontWeight: "600", color: "#0160F1" } }}
                />
                <Divider />
                <CardContent sx={{ ...styles.assetmasterCardContent, paddingTop: 4 }} >
                    <Grid container spacing={3} alignItems="flex-end">

                        {/* --- CHANGED: Provision Period Dropdown (Multi-select) --- */}
                        <Grid item xs={12} sm={6} md={5} lg={4} style={{ marginLeft: 16 }}>
                            <Typography sx={styles.fieldTitle}>Provision Period:</Typography>
                            <Box sx={{ position: "relative", width: '70%', }}>
                                <Select
                                    options={periodOptions}
                                    value={selectedPendingPeriods}
                                    onChange={(selectedOptions) => setSelectedPendingPeriods(selectedOptions || [])}
                                    isMulti
                                    closeMenuOnSelect={false}
                                    isSearchable
                                    isClearable
                                    placeholder="Select Periods"
                                    styles={selectStyles}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={6} md={5} lg={5} >
                            <Typography sx={styles.fieldTitle}>Business Unit:</Typography>
                            <Box sx={{ position: "relative", width: '55%' }}>
                                <Select
                                    options={businessUnitSelectOptions}
                                    value={pendingBusinessUnit}
                                    onChange={(selectedOptions) => setPendingBusinessUnit(selectedOptions || [])}
                                    isMulti
                                    closeMenuOnSelect={false}
                                    isSearchable
                                    isClearable
                                    placeholder="Choose Business Unit"
                                    styles={selectStyles}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={6} md={2} lg={2} sx={{ display: 'flex', justifyContent: isMobile ? 'flex-start' : 'flex-end' }}>
                            <SSPCommonButton btnText={"Download"} btnFunction={() => handleDownloadPendingApprovalFile()} />
                        </Grid>
                    </Grid>
                </CardContent>

                {/* --- Step 2: Upload --- */}
                <CardHeader
                    p={2} sx={{ ...styles.cardHeader, marginTop: 1 }}
                    title={"Step 2: Upload excel containing provisioning data"}
                    titleTypographyProps={{ sx: { fontSize: "16px", fontWeight: "600", color: "#0160F1" } }}
                />
                <Divider />
                <CardContent sx={styles.assetmasterCardContent} >
                    <Grid container spacing={3} alignItems="center">
                        <Grid item xs={12} sm={6} md={6} lg={4} xl={4} sx={styles.locContainer} >
                            <Box p={2} sx={{ ...styles.fileStyle, width: isMobile ? '100%' : '100%' }} >
                                <Box p={1} sx={styles.fileInputStyle} >
                                    <input type="file" ref={fileInputRef} multiple={false} onChange={(e) => setSelectedFile(e.target.files[0])} />
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} style={{ marginLeft: 16 }}>
                            <SSPCommonButton btnText="Save data" btnFunction={() => handleUpload()} />
                        </Grid>
                    </Grid>
                </CardContent>
                <CardHeader
                    p={2} sx={{ ...styles.cardHeader, marginTop: 1 }}
                    title={"Download previously reviewed provisions"}
                    titleTypographyProps={{ sx: { fontSize: "16px", fontWeight: "600", color: "#0160F1" } }}
                />
                <Divider />
                <CardContent sx={{ ...styles.assetmasterCardContent, paddingTop: 4 }} >
                    <Grid container spacing={3} alignItems="flex-end">

                        <Grid item xs={12} sm={6} md={3.3} lg={3} style={{ marginLeft: 16 }} >
                            <Typography sx={styles.fieldTitle}>Provision Period:</Typography>
                            <Box sx={{ position: "relative", width: '85%' }}>
                                <Select
                                    options={periodOptions}
                                    value={selectedReviewedPeriods}
                                    onChange={(selectedOptions) => setSelectedReviewedPeriods(selectedOptions || [])}
                                    isMulti
                                    closeMenuOnSelect={false}
                                    isSearchable
                                    isClearable
                                    placeholder="Select Periods"
                                    styles={selectStyles}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3.3} lg={3}>
                            <Typography sx={styles.fieldTitle}>Business Unit:</Typography>
                            <Box sx={{ position: "relative", width: '85%' }}>
                                <Select
                                    options={businessUnitSelectOptions}
                                    value={businessUnit}
                                    onChange={(selectedOptions) => setBusinesUnit(selectedOptions || [])}
                                    isMulti
                                    closeMenuOnSelect={false}
                                    isSearchable
                                    isClearable
                                    placeholder="Choose Business Unit"
                                    styles={selectStyles}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3.3} lg={3}>
                            <Typography sx={styles.fieldTitle}>Status:</Typography>
                            <Box sx={{ position: "relative", width: '85%' }}>
                                <Select
                                    options={statusSelectOptions}
                                    value={statusSelectOptions.find(opt => opt.value === status)}
                                    onChange={(selectedOption) => setStatus(selectedOption?.value || "")}
                                    isSearchable
                                    isClearable
                                    placeholder="Choose Status"
                                    styles={selectStyles}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12} lg={2} sx={{ display: 'flex', justifyContent: isMobile ? 'flex-start' : 'flex-end' }}>
                            <SSPCommonButton btnText={"Download"} btnFunction={() => handleDownloadFile()} />
                        </Grid>
                    </Grid>
                </CardContent>

                {/* --- Section 4: Table --- */}
                <Card sx={{ ...styles.provisiontablecard, paddingHorizontal: 0 }} >
                    <CardHeader
                        p={2} sx={styles.cardHeader}
                        title={"Uploaded Files"}
                        titleTypographyProps={{ sx: { fontSize: "16px", fontWeight: "600", color: "#0160F1" } }}
                        action={<Button onClick={() => window.location.reload()}>Refresh Page</Button>}
                    />
                    <Divider />
                    <CardContent sx={styles.assetmasterCardContent} >
                        <Box sx={{ backgroundColor: "#FFFFFF", borderRadius: "5px", padding: isMobile ? "8px" : "16px", height: 700 }}>
                            <DataGrid
                                rowHeight={80}
                                showCellRightBorder={true}
                                // sx={{
                                //     ".MuiDataGrid-columnHeaderTitle": { fontWeight: "bold !important" },
                                //     overflowX: "auto",
                                // }}
                                sx={{
                                    ".MuiDataGrid-columnHeaderTitle": {
                                        fontWeight: "bold !important",
                                        fontSize: isMobile ? "0.7rem" : "0.875rem",
                                    },
                                    ".MuiDataGrid-cell": {
                                        fontSize: isMobile ? "0.6rem" : "0.8rem",
                                        padding: isMobile ? "4px" : "8px",
                                    },
                                    ".MuiDataGrid-root": {
                                        minWidth: isMobile ? "50%" : "auto",
                                    },
                                    overflowX: "auto",

                                }}
                                rows={row}
                                columns={columns}
                                initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
                                pageSizeOptions={[10]}
                                getRowId={(row) => row.id}
                                components={{ Toolbar: GridToolbar }}
                                componentsProps={{ Toolbar: { showQuickFilter: true, quickFilterProps: { debounceMs: 500 } } }}
                            />
                        </Box>
                    </CardContent>
                </Card>
            </Card>
            {modalOpener && <SSPCommonModal open={modalOpener} handleOpenClose={setmodalOpener} message={message} />}
        </Box>
    )
}

export default ApproveProvisions;
